import { render, staticRenderFns } from "./PaymentUseVega.vue?vue&type=template&id=21bf72aa"
import script from "./PaymentUseVega.vue?vue&type=script&lang=js"
export * from "./PaymentUseVega.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports